import FormattedMessage from 'I18n/components/FormattedMessage';
import { H4 } from 'foundations-components/transitional/components/H4';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ApprovalNotRequestedI18nMessage } from '../i18n/ApprovalNotRequestedI18n';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNotRequested(props) {
  const {
    approvalType,
    approvalAction
  } = props;
  return /*#__PURE__*/_jsxs(View, {
    padding: "500",
    as: "div",
    children: [/*#__PURE__*/_jsxs(TFlex, {
      alignItems: "center",
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(StatusDot, {
        use: "disabled"
      }), /*#__PURE__*/_jsx(H4, {
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalNotRequested.header"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      as: "div",
      children: /*#__PURE__*/_jsx(ApprovalNotRequestedI18nMessage, {
        approvalType: approvalType,
        approvalAction: approvalAction
      })
    })]
  });
}
export default ApprovalNotRequested;